// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"37":"56e8e037cff488c994bf","316":"0f94cd5d41fab2e70418","364":"2d928a022709f5246016","437":"255121e77459570b08e6","581":"8432a215741ebb7b5dff"}[chunkId] + ".js";
};